import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

const MenuStateContext = React.createContext(undefined);
const MenuDispatchContext = React.createContext(undefined);

export function ModalMenuProvider({ children }: Props) {
  const [showSidebar, setShowSidebar] = React.useState(true);

  return (
    <MenuStateContext.Provider value={showSidebar}>
      <MenuDispatchContext.Provider value={setShowSidebar}>
        {children}
      </MenuDispatchContext.Provider>
    </MenuStateContext.Provider>
  );
}

function useMenuState() {
  const context = React.useContext(MenuStateContext);
  return context;
}

function useMenuDispatch() {
  const context = React.useContext(MenuDispatchContext);
  return context;
}

export function useModalMenu() {
  return [useMenuState(), useMenuDispatch()];
}
